export default __webpack_public_path__ + "static/media/vehicle.b6c570aa261ccc76fc1aed4f61cfcb2d.svg";